import React from 'react';
import PropTypes from 'prop-types';

const learning_25_05_2025 = () => (

    <div>
      
      <h1>Hello Style!</h1>
      <p>Add a little style.</p>
       <h1>
         Hello Jesse Hall!
       </h1>
       <h1>
         Component1
       </h1>
        




    </div>
);

learning_25_05_2025.propTypes = {};

learning_25_05_2025.defaultProps = {};

export default learning_25_05_2025;
